import { render, staticRenderFns } from "./RichTextEditor.vue?vue&type=template&id=4a2a58f4&"
import script from "./RichTextEditor.vue?vue&type=script&lang=js&"
export * from "./RichTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./editor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports